<template>
  <div style="display: inline-block;">
    <div class="img-wrap" v-if="memberInfo.ykWorkPhoneInfo && Number(memberInfo.yk_sms) === 1">
      <img v-if="memberInfo.ykWorkPhoneInfo" src="@/assets/img/shouji-sms.png" @click="handleShoujiSms" alt=""
        :style="`width:${size}px;`" />
    </div>

    <!-- 工作手机短信发送弹窗 -->
    <el-dialog title="工作手机短信发送" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px"
      @close="closeDialog" append-to-body>
      <el-form :model="smsForm" :rules="smsRules" ref="smsForm" label-width="100px">
        <el-form-item label="历史短信" prop="historyId">
          <el-select v-model="smsForm.historyId" placeholder="请选择历史短信" filterable clearable style="width: 100%"
            @change="handleHistoryChange" popper-class="history-sms-select-dropdown">
            <el-option v-for="item in historyList" :key="item.id" :label="item.content" :value="item.id">
              <span class="history-sms-option">{{ item.content }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="短信内容" prop="content">
          <el-input v-model="smsForm.content" type="textarea" :rows="6" placeholder="请输入短信内容" maxlength="500"
            show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendSms" :loading="sendLoading">发 送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: [String, Number],
      default: "18",
    },
    caseId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      memberInfo: JSON.parse(localStorage.getItem("user")).memberInfo,
      dialogVisible: false,
      sendLoading: false,
      smsForm: {
        historyId: '',
        content: ''
      },
      smsRules: {
        content: [
          { required: true, message: '请输入短信内容', trigger: 'blur' },
          { max: 500, message: '最多输入500个字符', trigger: 'blur' }
        ]
      },
      historyList: []
    }
  },
  methods: {
    handleShoujiSms() {
      this.dialogVisible = true
      this.getHistoryList()
      this.$nextTick(() => {
        this.$refs.smsForm && this.$refs.smsForm.clearValidate()
      })
    },

    // 获取历史短信列表
    getHistoryList() {
      this.get('osapi/yksms/getSms')
        .then(res => {
          let { code, msg, data } = res.data
          if (code !== 1) {
            this.$message({
              message: msg,
              type: 'error'
            })
          } else {
            this.historyList = data || []
          }
        })
    },

    // 历史短信选择变化
    handleHistoryChange(val) {
      if (val) {
        const selectedItem = this.historyList.find(item => item.id === val)
        if (selectedItem) {
          this.smsForm.content = selectedItem.content
        }
      }
    },

    // 关闭弹窗
    closeDialog() {
      this.$refs.smsForm.resetFields()
    },

    // 发送短信
    sendSms() {
      this.$refs.smsForm.validate((valid) => {
        if (valid) {
          this.sendLoading = true
          const params = {
            case_id: this.caseId,
            content: this.smsForm.content
          }

          this.post('osapi/yksms/send', params)
            .then(res => {
              let { code, msg, data } = res.data
              console.log(res.data)
              if (code != 1) {
                // code == 3 表示返回了敏感词
                if (code == 3 && data) {
                  // 提取敏感词并加粗显示
                  const message = `短信内容包含${String(data.types)}类敏感词：<strong>${String(data.keywords)}</strong>`
                  this.$message({
                    type: 'error',
                    message: message,
                    dangerouslyUseHTMLString: true,
                    duration: 5000
                  })
                } else {
                  // 其他错误情况
                  this.$message({
                    type: 'error',
                    message: msg
                  })
                }
              } else {
                this.$message({
                  type: 'success',
                  message: '发送成功'
                })
                this.dialogVisible = false
              }
            })
            .finally(() => {
              this.sendLoading = false
            })
        }
      })
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.img-wrap {
  cursor: pointer;
}

.history-sms-option {
  display: inline-block;
  max-width: 480px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style>
/* 全局样式，用于控制下拉弹出层的宽度 */
.history-sms-select-dropdown {
  max-width: 600px !important;
}

.history-sms-select-dropdown .el-select-dropdown__item {
  max-width: 580px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ShouJiSms.vue